module.exports = __webpack_public_path__ + "static/brand9-cfcc726160da7c69f76c760417cb9ed4.jpg";